/*
Runs a callback once the page has finished loading and its first content is on
screen, so background fetches (radio meta, ticker feed, hidden carousel slides,
the feed top-up) never compete with the hero image. Waiting for `load` alone is
not enough: when the browser paints after `load`, every request started before
the paint lands in Lighthouse's LCP estimate (home page 96 → 75). The browser's
own first-contentful-paint record is the signal; two animation frames stand in
where paint timing is missing, since they fire a moment before the frame is
shown. In a hidden tab nothing paints, so the work waits until the tab is shown.
After a PJAX swap the page is already loaded and painted: the callback runs at once.
*/

const FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';

export default function afterLoad(callback) {
    if (document.readyState === 'complete') {
        callback();
        return;
    }
    window.addEventListener('load', () => afterFirstPaint(callback), { once: true });
}

function afterFirstPaint(callback) {
    if (!PerformanceObserver.supportedEntryTypes?.includes('paint')) {
        requestAnimationFrame(() => requestAnimationFrame(callback));
        return;
    }
    // buffered: a paint recorded before this call is delivered too.
    const observer = new PerformanceObserver((list) => {
        if (list.getEntriesByName(FIRST_CONTENTFUL_PAINT).length) {
            observer.disconnect();
            callback();
        }
    });
    observer.observe({ type: 'paint', buffered: true });
}
